<template>
  <div>
    <ion-item lines="none">
      <ion-item class="search">
        <ion-label position="floating">
          Search
        </ion-label>
        <ion-input-vue v-model="search" />
      </ion-item>

      <ion-button
        slot="end"
        @click="add"
      >
        <ion-icon :src="i.add" />
        Create new API client
      </ion-button>
    </ion-item>

    <v-data-table
      :headers="headers"
      :items="clients"
      :items-per-page="50"
      :footer-props="{'items-per-page-options':[15, 30, 50, 100, -1]}"
      :search="search"
      :loading="busy"
    >
      <template v-slot:item.uuid="{ value }">
        <copyable-code
          :code="value"
          :length="8"
        />
      </template>

      <template v-slot:item.secret="{ value }">
        <copyable-code
          :code="value"
          :length="3"
        />
      </template>

      <template v-slot:item.revoked="{ value }">
        <ion-badge
          v-if="value"
          class="offline hydrated"
        >
          No
        </ion-badge>
        <ion-badge
          v-else
          class="online hydrated"
        >
          Yes
        </ion-badge>
      </template>

      <template v-slot:item.createdAt="{ value }">
        {{ value | datetime }}
      </template>

      <template v-slot:item.actions="{ item }">
        <ion-spinner v-if="item.busy" />
        <template v-else>
          <ion-button
            v-if="item.revoked"
            fill="clear"
            @click="accept(item)"
          >
            <ion-icon
              :src="i.checkmark"
              color="success"
            />
          </ion-button>
          <ion-button
            v-else
            fill="clear"
            @click="revoke(item)"
          >
            <ion-icon
              :src="i.close"
              color="danger"
            />
          </ion-button>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from 'vue'

import { VDataTable } from 'vuetify/lib'
import { IonInputVue } from '@modus/ionic-vue'

import { modalController } from '@modus/ionic-vue'

import ExternalApiClient from './ExternalApiClient'
import ClientId from './ClientId'
import Secret from './Secret'
import Active from './Active'

import CopyableCode from '../../common/CopyableCode'

export default {
  components: {
    VDataTable,
    CopyableCode,
    IonInputVue
  },
  data() {
    return {
      serialNumber: this.$route.params.serialNumber,
      headers: [
        {
          text: 'Client ID',
          value: 'uuid'
        },
        {
          text: 'Secret',
          value: 'secret'
        },
        {
          text: 'Provider',
          value: 'provider'
        },
        {
          text: 'Active',
          value: 'revoked'
        },
        {
          text: 'Created at',
          value: 'createdAt'
        },
        {
          value: 'actions',
          sortable: false
        }
      ],
      search: '',
      busy: false
    }
  },
  computed: {
    bridge() {
      return this.$store.getters.getBridgeBySerial(this.serialNumber)
    },
    clients() {
      return this.bridge.externalClients
    }
  },
  created() {
    const serialNumber = this.serialNumber

    this.busy = true

    this.$store.dispatch('fetchExternalApiClients', { serialNumber })
      .finally(() => this.busy = false)
  },
  methods: {
    revoke(client) {
      this.changeExternalApiClientState(client, 'revokeExternalApiClient')
    },
    accept(client) {
      this.changeExternalApiClientState(client, 'acceptExternalApiClient')
    },
    changeExternalApiClientState(client, action) {
      const serialNumber = this.$route.params.serialNumber
      const uuid = client.uuid

      Vue.set(client, 'busy', true)

      this.$store.dispatch(action, { serialNumber, uuid })
        .finally(() => client.busy = false)
    },
    async add() {
      const client = {
        provider: 1
      }

      const modal = await modalController
        .create({
          component: ExternalApiClient,
          componentProps: {
            propsData: {
              client
            }
          },
          cssClass: 'external-client-modal'
        })

      modal.present()
    }
  },
}
</script>
